export default "__VITE_ASSET__b775268b__"